import { registerAppNamespace } from '@aaas/shared';

import enPortal from './locales/en/portal.json';
import viPortal from './locales/vi/portal.json';

let registered = false;

export function registerPortalNamespace() {
  if (registered) return;
  registered = true;
  registerAppNamespace('portal', { en: enPortal, vi: viPortal });
}
